import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/confidence-interval-calculator',
  component: () => import('../../routes/ConfidenceIntervalCalculator.svelte'),
  card: {
    id: 'confidence-interval-calculator',
    title: 'Confidence Interval Calculator',
    description: 'Calculate confidence intervals for a population mean using z-distribution or t-distribution. Enter your sample data to estimate the range where the true population mean lies.',
    icon: 'analytics',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/confidence-interval-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Confidence Interval Calculator – Estimate Population Mean Range',
    description: 'Free confidence interval calculator. Calculate the margin of error and range for a population mean using z-distribution or t-distribution. Works with any sample size and confidence level.',
  },
};

export default meta;
